import { navigationService } from 'src/services/navigation-service';
import { setLastVisitedProductDetailsPage, setReachedStep } from 'src/state/order/order-slice';
import { OrderStep } from 'src/state/order/types';
import { AppDispatch } from 'src/state/types';
import { OrderStepService } from 'src/utils/order-step-service';

export const goToStepActionCreator = (step: OrderStep, replacePath?: boolean) => (dispatch: AppDispatch) => {
  dispatch(setReachedStep(step));

  if (step === 'PURCHASE_DECODER' || step === 'UPGRADE_DECODER') {
    dispatch(setLastVisitedProductDetailsPage(step));
  }

  if (replacePath) {
    navigationService.replacePath(OrderStepService.getStepPath(step));
  } else {
    navigationService.goToPath(OrderStepService.getStepPath(step));
  }
};
